import styled from 'styled-components';
import { from } from 'styles/mixins';

export const Container = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  justify-content: center;
  padding: 0.5rem ${({ theme }) => theme.wrapperPaddingH.mobile};
  text-align: center;

  ${from.tablet`
    padding: 0.5rem ${({ theme }) => theme.wrapperPaddingH.desktop};
  `};
`;

export const Message = styled.span`
  font-size: 0.875rem;
  font-weight: ${({ theme }) => theme.weights.semiBold};
`;

export const Name = styled.strong`
  font-weight: ${({ theme }) => theme.weights.bold};
`;

export const StopButton = styled.button`
  background-color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.error};
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  padding: 0.25rem 0.75rem;
  text-transform: uppercase;
`;
